import ApiUtil from '@/api/api.util'
import ApiConfig from '@/api/api.config'
import EtnersCommonUtil from "../../../common/etners.common.util";


const platformDomain = ApiConfig.platformDomain
const gewApiDomain = sessionStorage.gewApiDomain

const gewCodeRequestStoreModule = {
  state    : {
    dataSource: {
      lastRequestParameters: {},
    },
  search   : {
    combobox: {
      businessPlace: {
        type: 'combobox',
        data: [],
        index: 0,
      },
      division: { //
        type: 'combobox',
        data: [],
        index: 0,
      }

    },
  },
    currentRow: {
      currentRowData: [], // kendo grid에서 행위가 일어나는 row의 data

    },
  },
  getters  : {},
  mutations: {
    setBusinessPlaceIndex (state, index) {
      state.search.combobox.businessPlace.index = index
    },
    setBusinessPlaceData (state, data) {
      state.search.combobox.businessPlace.data = data
    },
    setDivisionData (state, data) {
      state.search.combobox.division.data = data
    },
    setDivisionIndex (state, index) {
      state.search.combobox.division.index = index
    }
  },
  actions  : {

    /**********************************************************************
     * [주의사항]
     * actions 안에 정의하는 함수는 모듈별로 네임스페이스를 구분하지 않으므로,
     * 다른 모듈에서 사용하는 이름을 중복으로 사용하지 않아야 합니다.
     *
     * vue 모듈 안의 함수에서는 다음과 같이 호출이 가능합니다.
     *
     * this.$store.dispatch('initSearchDataForCodeRequest')
     *********************************************************************/

    /**
     * 페이지 로딩시 최초로 검색창 세팅.
     * 데이터를 ajax로 가져와서 세팅해야합니다.
     */
    initGewSearchDataForCodeRequest(context) {

      /** 여러개의 공통 코드를 동시에 요청할 경우에 대한 파라미터값 */
      const url = `https://single.etnersplatform.com/v1/ebmp/code/multiSolutionCodes.json`
      const data = {
        'solutionCodes': [
          {
            'cdGrup': '001',
            'solCd': '1007',
            'options': {
              'displayAll': false,
            },
          },
          {
            'cdGrup': '002',
            'solCd': '1007',
            'options': {
              'displayAll': false,
            },
          }
        ],
      }
      const sessionUserData = JSON.parse(sessionStorage.loginUserData)
      ApiUtil.post(url, data).then(response => {
        let solutionCodeMap = response.data.solutionCodeMap

        const businessPlaceCdArray = sessionUserData.businessPlaceCds

        const neBusinessPlaceData = []
        let businessPlaceArray = []

        // 사업장
        businessPlaceArray = solutionCodeMap['001']


        businessPlaceArray = EtnersCommonUtil.sortArray(businessPlaceArray, 'seqNo')
        context.commit('setBusinessPlaceData', businessPlaceArray)


        for (let i = 0; i < businessPlaceArray.length; i++) {
          const code = businessPlaceArray[i]

          if (code.selected === true) {
            context.commit('setBusinessPlaceIndex', i)
          }
        }

        // 사업부
        const divisionCdArray = sessionUserData.divisionCds

        let divisionArray = []

        // 사업부
        divisionArray = solutionCodeMap['002']

        divisionArray = EtnersCommonUtil.sortArray(divisionArray, 'seqNo')
        context.commit('setDivisionData', divisionArray)

        for (let i = 0; i < divisionArray.length; i++) {
          const code = divisionArray[i]

          if (code.selected === true) {
            context.commit('setDivisionIndex', i)
          }
        }
      })
    }
  }
}

export default gewCodeRequestStoreModule
